import { createFileRoute } from "@tanstack/react-router";
import z from "zod";
import { BrowserUpgradePage } from "@/features/browser-upgrade/browser-upgrade-page";
import { seo, SEO_SITE_URL } from "@/lib/utils/seo";

export const Route = createFileRoute("/browser-upgrade")({
  validateSearch: z.object({
    redirect: z.string().optional(),
  }),
  head: () => ({
    meta: [
      ...seo({
        title: "请升级浏览器 - CN Apex Club",
        description: "当前浏览器版本过旧，无法完整支持新版界面。请更新到最新版本后继续访问。",
        url: `${SEO_SITE_URL}/browser-upgrade`,
      }),
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  const search = Route.useSearch();

  return (
    <BrowserUpgradePage
      redirect={search.redirect}
      onNavigate={(path) => navigate({ to: path, replace: true })}
    />
  );
}
